import { cn } from "@/lib/utils";
import logoImage from "@/assets/design/logo.png";

interface BrandLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  showBackground?: boolean;
}

export function BrandLogo({ className, size = "lg", showBackground = false }: BrandLogoProps) {
  const sizeClasses = {
    sm: "w-16 h-16",
    md: "w-24 h-24", 
    lg: "w-32 h-32",
    xl: "w-48 h-48"
  };

  return (
    <div 
      className={cn(
        "relative flex items-center justify-center",
        sizeClasses[size],
        showBackground && "bg-figma-primary rounded-figma-button p-4",
        className
      )}
    >
      <img 
        src={logoImage} 
        alt="TendencIA Logo"
        className="w-full h-full object-contain"
      />
    </div>
  );
}